//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { observer } from "mobx-react-lite";
import Pluralize from "pluralize";
import React, { useState } from "react";
import { array, boolean, object, string } from "yup";
import ExpandingTextArea from "../components/form-elements/ExpandingTextArea";
import { XButton } from "../components/ui-elements/Icon";
import Upload from "../components/Upload";
// import { UploadIcon } from "../icons";
import { IUploadStore } from "../stores";
import { scrollToId } from "../utils/functions";
import { AccordionFormField } from "../_new_/components/accordion-form-field/AccordionFormField";
import { SingleFormButton } from "./forms/FormButtons";

export const createValidationSchema = (fields, prefix = "") => {
  let validationFields = fields.filter((field) => Boolean(field.required));
  let validationObject = {};
  validationFields.forEach((element) => {
    let options = {
      multiselect: () =>
        array().min(1, `${element.heading} field is required`).required(),
      radio: () => boolean().required(),
      input: () =>
        string()
          .transform((r) => r.replace(/ +/g, " "))
          .required(),
      "accordion-multi": () =>
        array().min(1, `${element.heading} field is required`).required(),
    };
    validationObject[element.name] = options[element.type]();
  });
  let validationSchema = object().shape(validationObject);
  return validationSchema;
};

let commonProps = (
  { name }: { name: any },
  { touched, errors }: { touched: any; errors: any }
) => ({
  // ...placeholders[name],
  isInvalid: Boolean(errors[name]),
  errorMessage: errors[name],
});

export const MultiSelectCustomAccordion: React.FC<{
  examsObject: any;
  onChange: (vals: any) => any;
  defaultValues?: any;
}> = ({ examsObject, onChange, defaultValues = {} }) => {
  let examsSpeciality = defaultValues;
  let [values, setValues] = React.useState(examsSpeciality);

  function handleChange(key, value) {
    const allValues = { ...values, [key]: value };
    setValues(allValues);
    onChange(allValues);
  }
  function examsSelected(exam) {
    let examGroups = Object.keys(examsSpeciality);
    let examIsSelected = examGroups.length > 0 && examGroups.includes(exam);
    return examIsSelected ? examsSpeciality[exam].length : 0;
  }

  return (
    <AccordionFormField
      options={Object.keys(examsObject)}
      isValid={(item) => {
        return examsSelected(item) > 0;
      }}
      heading={(isExpanded, key) => {
        return (
          <>
            <Text fontWeight="medium">{key}</Text>
            {!isExpanded && examsSelected(key) > 0 && (
              <Text fontSize="sm" color="blue.500">
                {`${Pluralize("exam", examsSelected(key), true)} selected`}
              </Text>
            )}
          </>
        );
      }}
      renderFormField={(key) => {
        let options = examsObject[key];
        return (
          <CheckboxGroup
            colorScheme="blue"
            size="lg"
            onChange={(v) => {
              handleChange(key, v);
            }}
            defaultValue={values[key] || []}
          >
            <Stack spacing={6}>
              {options.map((option, i) => (
                <Checkbox borderColor={"neutral.800"} key={i} value={option}>
                  <Text fontSize="md" color={"neutral.900"} ml={1}>
                    {option}
                  </Text>
                </Checkbox>
              ))}
            </Stack>
          </CheckboxGroup>
        );
      }}
    />
  );
};

export const AccordionTextareaComponent: React.FC<{
  placeholder?: string;
  formField: {
    heading?: string;
    subHeading?: string;
    id?: string;
    name?: string;
    options?: any[];
    complex?: boolean;
    reasonLabel?: string;
    accordionFieldName: string;
  };

  onChange?: (...params: any[]) => void;
  form: any;
  field: any;
  value?: any;
  hasError?: boolean;
  errorMessage?: string;
  selectedText?: string;
  name?: string;
  additionalInfoRequired?: boolean;
  fullPayload?: boolean;
}> = ({
  placeholder = "E.g. I have a Cambridge Certification to teach the British Curriculum OR Having taught in Montessori schools for 6+ years, I am familiar with the Montessori system of teaching for early years",
  onChange,
  value = {},
  formField,
  form,
  field,
  hasError,
  errorMessage,
  selectedText = "Curriculum added",
  name = "curriculum_explanation",
  additionalInfoRequired = true,
  fullPayload = false,
}) => {
  const [selectedDescriptions, setSelectedDescriptions] =
    React.useState<any>(value);

  function onSubmit() {
    if (onChange) {
      if (fullPayload) {
        const selected = {};
        getSelectedItems(selectedDescriptions).forEach((item) => {
          selected[item] = selectedDescriptions[item];
        });
        onChange(selected);
      } else {
        onChange(getSelectedItems(selectedDescriptions));
      }
    }
  }

  function getSelectedItems(_value: any) {
    let selectedItems = Object.keys(_value).filter((key) => _value[key]);
    return selectedItems;
  }

  function localOnchange(latestValue: any) {
    form.setFieldValue(formField.accordionFieldName, latestValue);
    form.setFieldValue(field.name, getSelectedItems(latestValue));
  }

  function handleChange(vals) {
    const _values = { ...selectedDescriptions, ...vals };
    setSelectedDescriptions(_values);
    localOnchange(_values);
  }

  const [textAreaLength, setTextAreaLength] = useState(0);
  const [characterError, setCharacterError] = useState(false);

  const handleBlur = () => {
    if (additionalInfoRequired) {
      if (textAreaLength > 70) {
        setCharacterError(false);
        onSubmit();
      } else {
        setCharacterError(true);
      }
    }
  };
  return (
    <Stack spacing={6}>
      <Stack>
        <Text fontSize="lg" fontWeight="bold">
          {formField.heading}
        </Text>
        <Text color="gray.700">{formField.subHeading}</Text>
        {hasError && (
          <Text fontSize="sm" color="red.500">
            {errorMessage}
          </Text>
        )}
      </Stack>
      <AccordionFormField
        options={formField.options}
        isValid={(item) => {
          return Boolean(selectedDescriptions[item]);
        }}
        onAccordionClose={(key) => {
          onSubmit();
        }}
        heading={(isExpanded, key) => {
          return (
            <>
              <Text fontWeight="medium">{key}</Text>
              {!isExpanded &&
                selectedDescriptions[key] &&
                selectedDescriptions[key].replace(/ +/g, " ").trim() && (
                  <Text fontSize="sm" color="blue.500">
                    {selectedText}
                  </Text>
                )}
            </>
          );
        }}
        renderFormField={(key) => {
          console.log("key", key);
          return (
            <FormControl isInvalid={characterError}>
              <FormLabel htmlFor={key}>{formField.reasonLabel}</FormLabel>
              <ExpandingTextArea
                value={(selectedDescriptions[key] || "").replace(/ +/g, " ")}
                name={name}
                characterLimit={250}
                isInvalid={characterError}
                rows={4}
                onChange={(value) => {
                  const inputValue = value.replace(/ +/g, " ");
                  setCharacterError(false);
                  setTextAreaLength(inputValue.length);
                  handleChange({ [key]: inputValue });
                }}
                onBlur={handleBlur}
                placeholder={placeholder}
              />
              <FormErrorMessage>
                Please enter up to 70 characters to describe your expertise.
              </FormErrorMessage>
              <FormHelperText>Must be 70 characters at least</FormHelperText>
            </FormControl>
          );
        }}
      />
    </Stack>
  );
};

const MultiSelectComponent: React.FC<{
  onChange: (...params) => void;
  formField: {
    heading?: string;
    subHeading?: string;
    id?: string;
    name?: string;
    options?: any[];
    complex?: boolean;
  };
  touched?: boolean;
  disabledOptions?: string[];
  [key: string]: any;
  value: any;
}> = ({
  onChange,
  formField,
  disabledOptions = [],
  value,
  touched,
  ...rest
}) => {
  if (formField?.complex) {
    let transformedExamObject = {};
    formField.options.forEach((item) => {
      transformedExamObject[item.heading] = item.options;
    });
    return (
      <Stack spacing={6}>
        <Stack>
          <Text fontSize="lg" fontWeight="bold">
            {formField.heading}
          </Text>
          <Text color="gray.700">{formField.subHeading}</Text>
        </Stack>

        <MultiSelectCustomAccordion
          onChange={onChange}
          examsObject={transformedExamObject}
          defaultValues={value || {}}
        />
      </Stack>
    );
  }
  return (
    <Stack spacing={6}>
      <Stack>
        <Text fontSize="lg" fontWeight="bold">
          {formField.heading}
        </Text>
        <Text color="gray.700">{formField.subHeading}</Text>
      </Stack>
      <FormControl isInvalid={commonProps(rest.field, rest.form).isInvalid}>
        <CheckboxGroup
          size="lg"
          colorScheme="blue"
          defaultValue={value}
          onChange={onChange}
        >
          <Grid
            templateColumns="repeat(auto-fill, minmax(min(10rem, 100%), 1fr))"
            gap={6}
          >
            {formField.options.map((option, i) => (
              <Checkbox
                value={option}
                borderColor="neutral.500"
                isDisabled={disabledOptions.includes(option)}
                key={i}
              >
                <Text ml={1} fontSize="md">
                  {option}
                </Text>
              </Checkbox>
            ))}
          </Grid>
        </CheckboxGroup>
        <FormErrorMessage>
          {commonProps(rest.field, rest.form).errorMessage}
        </FormErrorMessage>
      </FormControl>
    </Stack>
  );
};

const TestResultVerification: React.FC<{
  onChange: (...params) => void;
  formField: {
    heading?: string;
    subHeading?: string;
    id?: string;
    name?: string;
    options?: any[];
    complex?: boolean;
  };
  [key: string]: any;
  value?: any;
  uploadStore: IUploadStore;
}> = ({ onChange, formField, value = {}, options, uploadStore, ...rest }) => {
  return (
    <Stack spacing={6}>
      <Stack>
        <Text fontSize="lg" fontWeight="bold">
          {formField.heading}
        </Text>
        <Text color="gray.700">{formField.subHeading}</Text>
      </Stack>
      <Box>
        <Upload
          allowMultiple={true}
          store={uploadStore}
          afterDrop={() => onChange(uploadStore.rawFiles)}
        >
          <XButton
            size="sm"
            leftIcon={"upload"}
            variant="outline"
            colorScheme="alphaBlack"
          >
            Upload proof
          </XButton>
        </Upload>
      </Box>
    </Stack>
  );
};

const RadioComponent: React.FC<{
  onChange: (...params) => void;
  formField: {
    heading?: string;
    subHeading?: string;
    id?: string;
    name?: string;
    options?: any[];
    complex?: boolean;
  };
  [key: string]: any;
  value: any;
}> = ({ onChange, formField, value, ...rest }) => {
  return (
    <FormControl isInvalid={commonProps(rest.field, rest.form).isInvalid}>
      <Stack mb={4}>
        <Text fontSize="lg" fontWeight="bold">
          {formField.heading}
        </Text>
        <Text color="gray.700">{formField.subHeading}</Text>
      </Stack>
      <RadioGroup value={value} onChange={onChange}>
        <Grid templateColumns="repeat(2, 1fr)" gap={6}>
          {formField.options.map((option) => {
            return (
              <Radio
                borderColor={"neutral.500"}
                cursor={"pointer"}
                colorScheme="blue"
                size="lg"
                value={option}
              >
                <Text>{option}</Text>
              </Radio>
            );
          })}
        </Grid>
      </RadioGroup>
      <FormErrorMessage>
        {commonProps(rest.field, rest.form).errorMessage}
      </FormErrorMessage>
    </FormControl>
  );
};

export const SwitchInput: React.FC<{
  onChange: (...params) => void;
  formField: {
    heading?: string;
    subHeading?: string;
    id?: string;
    name?: string;
    options?: any[];
    complex?: boolean;
  };
  [key: string]: any;
  value?: any;
}> = ({ onChange, formField, value = {}, ...rest }) => {
  const [showResult, setShowResult] = React.useState(
    Object.keys(value).length > 0
  );
  const [optionResult, setOptionResult] = React.useState(value);
  return (
    <Stack spacing={6}>
      <Stack>
        <Text fontSize="lg" fontWeight="bold">
          {formField.heading}
        </Text>
        <HStack justifyContent="space-between">
          <Text mr={6} color="gray.700">
            {formField.subHeading}
          </Text>
          <Switch
            size="lg"
            defaultChecked={showResult}
            onChange={({ target }) => {
              setShowResult(target.checked);
              if (!target.checked) {
                onChange({});
              }
            }}
            id="show-input"
          />
        </HStack>
      </Stack>

      {showResult && (
        <Stack spacing={4}>
          <Text fontWeight="medium">Input your test results</Text>
          {formField.options.map((test) => (
            <FormControl display="flex" alignItems="center" key={test}>
              <HStack>
                <Box width="35%">
                  <FormLabel fontWeight="normal" htmlFor="test-taken">
                    {test}
                  </FormLabel>
                </Box>

                <Input
                  flex={1}
                  name="test-taken"
                  id="test-taken"
                  focusBorderColor={"blue.500"}
                  colorScheme={"blue"}
                  value={optionResult[test] || ""}
                  onChange={(e) => {
                    const valueObject = {
                      ...optionResult,
                      [test]: e.target.value,
                    };
                    setOptionResult(valueObject);
                    onChange(valueObject);
                  }}
                  fontSize={"16px"}
                  borderColor={"neutral.500"}
                  placeholder={`${test} result`}
                />
              </HStack>
            </FormControl>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

const InputComponent: React.FC<{
  onChange: (...params) => void;
  formField: {
    heading?: string;
    subHeading?: string;
    id?: string;
    name?: string;
    options?: any[];
    complex?: boolean;
  };
  [key: string]: any;
  value: any;
}> = ({ onChange, formField, value, ...rest }) => {
  return (
    <Stack spacing={5}>
      <Stack>
        <Text fontSize="lg" fontWeight="bold">
          {formField.heading}
        </Text>
        <Text color="gray.700">{formField.subHeading}</Text>
      </Stack>

      <FormControl display="flex" alignItems="center">
        <Input
          focusBorderColor={"blue.500"}
          colorScheme={"blue"}
          fontSize={"16px"}
          size={"lg"}
          placeholder="E.g. Grange Schools, CIS, St. Saviors"
          borderColor={"neutral.500"}
          defaultValue={value}
          onChange={({ target }) => onChange(target.value)}
        />
        <FormErrorMessage>
          {commonProps(rest.field, rest.form).errorMessage}
        </FormErrorMessage>
      </FormControl>
    </Stack>
  );
};

export const generateFormComponent = (field) => {
  let options = {
    multiselect: MultiSelectComponent,
    radio: RadioComponent,
    input: InputComponent,
    proof: TestResultVerification,
    conditional: SwitchInput,
    "accordion-multi": AccordionTextareaComponent,
  };
  return options[field.type];
};

const TeachingPreference: React.FC<{
  uploadStore: IUploadStore;
  updatePreferences: (...params) => void;
  fields: any[];
  loading?: boolean;
  values?: any;
  onBackClick?: any;
  onSubmit: (vals: any) => any;
}> = observer(
  ({
    fields,
    loading,
    values = {},
    updatePreferences,
    onSubmit,
    onBackClick,
    uploadStore,
  }) => {
    const [showFormError, setShowFormError] = React.useState(false);
    const onSubmitClick = (errors = {}, values = {}) => {
      if (errors) {
        if (
          Object.values(errors).length ||
          Object.values(values).length === 0
        ) {
          setShowFormError(true);
          scrollToId("form-header-section");
        } else {
          setShowFormError(false);
        }
      }
    };
    const validationSchema = createValidationSchema(fields);
    return (
      <Box as="section">
        <Button
          mb={6}
          onClick={onBackClick}
          leftIcon={<ArrowBackIcon />}
          variant="link"
          colorScheme="blue"
        >
          Back
        </Button>

        <VStack justifyContent="stretch" alignItems="stretch" spacing={4}>
          <Formik
            validationSchema={validationSchema}
            initialValues={values}
            onSubmit={(vals) => {
              onSubmit(vals);
            }}
          >
            {({ handleSubmit, errors, values }) => {
              return (
                <form
                  onSubmit={(value) => {
                    handleSubmit(value);
                    onSubmitClick(errors, values);
                  }}
                >
                  <Stack id="form-header-section" mb={8} pb={20}>
                    <Stack pb={5}>
                      <Text
                        fontSize="3xl"
                        lineHeight="shorter"
                        fontWeight="bold"
                        as="h1"
                      >
                        Add preferences
                      </Text>
                      <Text mt={1} color="gray.700">
                        Help clients understand your tutoring background and
                        preferences
                      </Text>

                      {showFormError && (
                        <Box pt={2}>
                          <Alert rounded="lg" status="error">
                            <AlertIcon />
                            Error submitting forms, some fields are required
                          </Alert>
                        </Box>
                      )}
                    </Stack>

                    <Stack spacing={8}>
                      {fields.map((fieldItem, index) => {
                        return (
                          <Box key={index}>
                            <Field
                              name={fieldItem.name}
                              render={({ field, form }) => {
                                let display = true;
                                const FormComponent =
                                  generateFormComponent(fieldItem);
                                let props: any = {
                                  formField: fieldItem,
                                  value: field.value,
                                  field: field,
                                  form: form,
                                  uploadStore: uploadStore,
                                };
                                let rendered = display ? (
                                  <FormComponent
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                      // updatePreferences(field.name, value);
                                    }}
                                    value={field.value}
                                    // showVerification={showVerification}
                                    {...props}
                                  />
                                ) : null;
                                return (
                                  <Box className="render-component">
                                    {rendered}
                                  </Box>
                                );
                              }}
                            />
                          </Box>
                        );
                      })}
                    </Stack>
                  </Stack>

                  <SingleFormButton
                    mt={6}
                    nextText="Save preferences"
                    isLoading={loading}
                    onNextClick={handleSubmit}
                  />
                </form>
              );
            }}
          </Formik>
        </VStack>
      </Box>
    );
  }
);

export default TeachingPreference;
